export const INITIAL_PLAYER_INDEX = -1;
//# sourceMappingURL=initialPlayerIndex.js.map